export default "__VITE_ASSET__14bf22b6__"